import { FC, useState } from 'react';
import { AllieButton, AllieText } from '../../../../../components';
import { DataContentBaseProps } from './DataContent.types';

type TextProps = { text: string; maxLength?: number, labelButton?: string };

export const ContentText: FC<DataContentBaseProps<TextProps>> = ({ data: { text, maxLength, labelButton } }) => {
  const [showFullText, setShowFullText] = useState(false);

  if (maxLength && text.length > maxLength && !showFullText) {
    const truncatedText = text.substring(0, maxLength) + '...';
    return (
      <div>
        <AllieText type="body2">{truncatedText}</AllieText>
        <AllieButton
          expand="block"
          allieType="secondary"
          corner="rounded-edges"
          allieSize="small"
          onClick={() => setShowFullText(true)}
          style={{ marginTop: '1rem' }}
        >
          {labelButton}
        </AllieButton>
      </div>
    );
  }

  return (
    <div>
      <AllieText
        type="body2"
        style={{ whiteSpace: 'pre-wrap' }}
      >
        {text}
      </AllieText>
    </div>
  );
};
